import request from '@/plugin/axios'

export function apijhiusersoperatePriceApproval (data) {
    return request({
      url:'/api/jhi-users/operatePriceApproval',
      method: 'post',
      data:data
    })
  }
  export function apitombstombChangePriceByGroupId (params) {
    console.log(params);
    return request({
      url:'/api/tombs/tombChangePriceByGroupId',
      method: 'get',
      params:params
    })
  }
  